const userProfile = {
  emailManaged:
    'Your email is managed by your organization. Contact your administrator to change it.',
  actions: {
    backToChat: 'Back to chat',
    close: 'Close profile page',
  },
  account: {
    title: 'Account',
  },
  avatarEditor: {
    cancel: 'Cancel',
    choose: 'Choose image',
    chooseAnother: 'Choose another',
    close: 'Close avatar editor',
    cropFailed: 'Avatar cropping failed. Choose another image and try again.',
    edit: 'Edit avatar',
    fileHint: 'PNG / JPEG / GIF / WebP · 1 MB',
    preview: 'Avatar preview',
    remove: 'Remove avatar',
    save: 'Save avatar',
    title: 'Edit avatar',
    zoom: 'Zoom',
  },
  errors: {
    accountUnavailable: 'This account is unavailable. Contact an administrator.',
    avatarEmpty: 'Choose an avatar image first.',
    avatarInvalid: 'This avatar image is not valid. Choose another image.',
    avatarTooLarge: 'The avatar image exceeds the upload limit.',
    avatarUnsupported: 'Avatar images must be PNG, JPEG, GIF, or WebP.',
    forbidden: 'You do not have permission to perform this action.',
    generic: 'The operation failed. Please try again later.',
    missingPasswordFields: 'Enter the current password and the new password.',
    network: 'Network error. Check your connection and try again.',
    currentPasswordIncorrect: 'The current password is incorrect.',
    serviceUnavailable: 'The service is unavailable. Please try again later.',
    sessionExpired: 'Your session has expired. Sign in again.',
    timezoneInvalid: 'Enter a valid IANA timezone.',
  },
  fallbackName: 'User',
  fields: {
    confirmPassword: 'Confirm new password',
    currentPassword: 'Current password',
    displayName: 'Display name',
    newPassword: 'New password',
  },
  loadErrorDescription: 'Could not load the current account profile.',
  loadErrorTitle: 'Profile failed to load',
  nameEditor: {
    cancel: 'Cancel',
    close: 'Close name editor',
    edit: 'Edit display name',
    placeholder: 'Enter your display name',
    submit: 'Save name',
    title: 'Edit display name',
  },
  password: {
    cancel: 'Cancel',
    close: 'Close password editor',
    hidePassword: 'Hide password',
    modalTitle: 'Change password',
    reloginNotice:
      'After the password is saved, this session will be revoked and returned to login.',
    reset: 'Reset password',
    showPassword: 'Show password',
    submit: 'Save password',
    title: 'Password',
  },
  success: {
    avatarDeleted: 'Avatar removed',
    avatarUploaded: 'Avatar updated',
    passwordChanged: 'Password updated. Sign in again.',
    profileSaved: 'Profile saved',
    timezoneSaved: 'Timezone setting saved',
  },
  tabs: {
    basic: 'Basic info',
    label: 'Profile sections',
  },
  title: 'My profile',
  timezone: {
    automatic: 'Automatic',
    automaticDescription: 'Current device: {{location}} · {{timezone}}',
    automaticDescriptionUnavailable:
      'Read the current device timezone for each new chat, falling back to UTC when unavailable',
    automaticWithDevice: 'Automatic ({{timezone}})',
    description: 'Controls the timezone used by Agent time context and related system tools.',
    searchEmpty: 'No matching timezones',
    searchLabel: 'Search timezones',
    searchPlaceholder: 'Search city, timezone name, UTC offset, or IANA ID',
    sectionTitle: 'Preferences',
    title: 'Timezone',
  },
  validation: {
    confirmPasswordMismatch: 'The new passwords do not match.',
    currentPasswordRequired: 'Enter your current password.',
    nameRequired: 'Display name is required.',
    newPasswordLength: 'The new password must be at least 8 characters.',
  },
}

export default userProfile
